import _objectSpread from "reshow-runtime/es/helpers/objectSpread2";
import _slicedToArray from "reshow-runtime/es/helpers/slicedToArray";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { build, mixClass, lazyInject } from "react-atomic-molecule";
import get from "get-object-value";
import callfunc from "call-func";
import CSSTransition from "../organisms/CSSTransition";
import { UNMOUNTED, ENTERSTART, EXITED } from "../organisms/Transition";
import getChildMapping from "../../src/getChildMapping";
import { dataStatusKey } from "../../src/const";
var keys = Object.keys;

var getAniProps = function getAniProps(props, enterToAppear) {
  var statusKey = props.statusKey,
      timeout = props.timeout,
      delay = props.delay,
      classNames = props.classNames,
      mountOnEnter = props.mountOnEnter,
      unmountOnExit = props.unmountOnExit,
      enter = props.enter,
      exit = props.exit,
      addEndListener = props.addEndListener,
      onEnter = props.onEnter,
      onEntering = props.onEntering,
      onEntered = props.onEntered,
      onExit = props.onExit,
      onExiting = props.onExiting;
  var appear = props.appear;

  if (enterToAppear && classNames && classNames.enter) {
    classNames.appear = classNames.enter;
    delay.appear = delay.enter;
    timeout.appear = timeout.enter;
    appear = true;
  }
  /* not assign onExited, because call at handleExited */


  var aniProps = {
    statusKey: statusKey,
    timeout: timeout,
    delay: delay,
    classNames: classNames,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    appear: appear,
    enter: enter,
    exit: exit,
    addEndListener: addEndListener,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    "in": props["in"]
  };
  return aniProps;
};

var buildCSSTransition = build(CSSTransition);

var AnimateGroup = function AnimateGroup(props) {
  var className = props.className,
      component = props.component,
      lazy = props.lazy,
      onExited = props.onExited,
      style = props.style,
      statusKey = props.statusKey,
      otherProps = _objectWithoutProperties(props, ["className", "component", "lazy", "onExited", "style", "statusKey"]);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      children = _useState2[0],
      setChildren = _useState2[1];

  var mount = useRef(false);
  var aniProps = getAniProps(otherProps, true);
  keys(aniProps).forEach(function (key) {
    return delete otherProps[key];
  });
  useEffect(function () {
    injects = lazyInject(injects, InjectStyles({
      statusKey: statusKey
    }));
  }, []);
  useEffect(function () {
    var _exitTimeout;

    var _enterTimeout;

    mount.current = true;

    var handleExited = function handleExited(child) {
      return function (node) {
        callfunc(onExited, [node]);
        _exitTimeout = setTimeout(function () {
          if (mount.current) {
            setChildren(function (children) {
              delete children[child.key];
              return _objectSpread({}, children);
            });
          }
        });
      };
    };

    var prevChildMapping = children || {};
    var nextChildMapping = getChildMapping(otherProps.children, function (child, key) {
      return buildCSSTransition(_objectSpread({}, child.props, {}, aniProps, {
        key: get(child, ["props", "name"], key),
        onExited: handleExited(child)
      }), child);
    });

    var allChildMapping = _objectSpread({}, prevChildMapping, {}, nextChildMapping);

    keys(allChildMapping).forEach(function (key) {
      var child = allChildMapping[key];
      var hasPrev = (key in prevChildMapping);
      var hasNext = (key in nextChildMapping);
      var prevChild = prevChildMapping[key];
      var isLeaving = !get(prevChild, ["props", "in"]);

      if (!hasNext && hasPrev) {
        // Will Exit
        if (!isLeaving) {
          allChildMapping[key] = build(child)({
            "in": false
          });
        }
      }
    });

    if (!children) {
      _enterTimeout = setTimeout(function () {
        return setChildren(allChildMapping);
      }, lazy);
    } else {
      setChildren(allChildMapping);
    }

    return function () {
      clearTimeout(_exitTimeout);
      clearTimeout(_enterTimeout);
      mount.current = false;
    };
  }, [props.children]);
  return useMemo(function () {
    otherProps.style = _objectSpread({
      overflow: "hidden"
    }, style);
    otherProps.className = mixClass(className, "animate-group-container");
    return build(component)(otherProps, keys(children || {}).map(function (key) {
      return children[key];
    }));
  }, [children]);
};

AnimateGroup.defaultProps = {
  statusKey: dataStatusKey,
  lazy: 150,
  component: "div",
  unmountOnExit: true,
  "in": true
};
export default AnimateGroup;
var injects;

var InjectStyles = function InjectStyles(_ref) {
  var statusKey = _ref.statusKey;
  return {
    init: [{
      visibility: "hidden"
    }, ["[".concat(statusKey, "=\"").concat(UNMOUNTED, "\"]"), "[".concat(statusKey, "=\"").concat(ENTERSTART, "\"]")].join(",")],
    exit: [{
      display: "none"
    }, "[".concat(statusKey, "=\"").concat(EXITED, "\"]")]
  };
};